import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import AlertBanner from "canvas-core-react/lib/AlertBanner";
import contactProvider from "../../../../static/images/contactProvider.svg";
import IconAddNew from "canvas-core-react/lib/IconAddNew";

import {
  errorContainer,
  loadingHtml,
  sucessInfoModal,
} from "../../utils/functions";
import BillDetails from "../../private/billDetails";
import CustomSelect from "../custom-components/customSelect";
import Modal from "../../utils/customModal";
import parser from "html-react-parser";
import useApi from "../../hooks/useApi";
import useForm from "../../hooks/useForm";

const DetailStatus = ({ id, goBack }) => {
  const [data, setData] = useState({});
  const [modal, setModal] = useState(defaultModal);
  const [alert, setAlert] = useState(null);

  const { getApiCAll, postApiCAll } = useApi();
  const { t } = useTranslation();

  const texts = t("report.billStatus", {
    returnObjects: true,
    interpolation: { escapeValue: false },
  });

  useEffect(() => {
    const getData = async () => {
      try {
        setModal({ show: true, content: loadingHtml() });
        const response = await getApiCAll(`/parameters/bills/${id}`);
        setData(response.data.data);
        closeModal();
      } catch (err) {
        setErrorMessage(err.response?.data?.notifications[0]?.description);
      }
    };

    getData();
  }, []);

  const setErrorMessage = (message) => {
    setModal({
      show: true,
      content: errorContainer("Error", message, {
        continueBtn: {
          text: t("general.buttons.continue"),
          action: closeModal,
        },
      }),
    });
  };

  const closeModal = () => setModal(defaultModal);

  const callback = ({ status, referenceNumber }) => {
    if (status === "PAID_REJECTED") return;
    if (status === "PAID" && !referenceNumber) return setAlert("error");

    const getText = (ref) => `report.billStatus.modal.${ref}`;

    const buttonsText = t("general.buttons", { returnObjects: true });

    setModal({
      show: true,
      content: sucessInfoModal(
        t(getText("title")),
        t(getText("description"), {
          state: t(`general.states.${states[status]}`),
        }),
        {
          SelBtn: { action: closeModal, text: buttonsText["cancel"] },
          formBtn: {
            action: () => handleUpdate({ newStatus: status, referenceNumber }),
            text: buttonsText["changeState"],
          },
        }
      ),
    });
  };

  const handleUpdate = async ({ newStatus, referenceNumber }) => {
    try {
      setModal({ show: true, content: loadingHtml() });
      await postApiCAll("/parameters/bills", {
        id,
        newStatus,
        referenceNumber,
      });
      closeModal();
      setAlert("success");
    } catch (err) {
      setErrorMessage(err.response?.data?.notifications[0]?.description);
    }
  };

  const { handleChange, values, onSubmit } = useForm({
    initialState: { status: "PAID_REJECTED", referenceNumber: "" },
    callback,
  });

  return (
    <>
      <div className="bill-change-status">
        <div className="d-flex align-items-center">
          <img src={contactProvider} className="iconList" />
          <h3 className="title">{texts.title}</h3>
        </div>
        <div className="my-5">
          <p>{texts.text1}</p>
          <p>{parser(texts.text2)}</p>
          <p>{texts.text3}</p>
          <p>{parser(texts.text4)}</p>
          <p>{parser(texts.text5)}</p>
        </div>
        <div className="bill-form-container">
          <div className="d-flex justify-content-between">
            <div className="d-flex flex-column">
              <>
                <h3 style={{ marginBottom: "-15px" }}>{texts.title}</h3>
                <CustomSelect
                  className="bill-status-select"
                  name="status"
                  items={Object.keys(states).map((key) => ({
                    label: t(`general.states.${states[key]}`),
                    value: key,
                  }))}
                  onChange={handleChange}
                  value={values.status}
                />
              </>
              <div className="bill-reason-input mt-5">
                <label className="label">{texts.reference}</label>
                <input
                  className="input input--text input--active"
                  name="referenceNumber"
                  onChange={handleChange}
                  value={values.referenceNumber}
                />
                <IconAddNew />
              </div>
            </div>
            <div className="input bill-status-width">
              <label className="label">{texts.reason}</label>
              <span className="input" style={{ fontSize: "1.7rem" }}>
                {data?.rejectionMessage}
              </span>
            </div>
          </div>

          {alert && (
            <AlertBanner className="mt-5" type={alert}>
              {texts.alert[alert]}
            </AlertBanner>
          )}
        </div>
        <div className="d-flex align-items-center mb-5">
          <img src={contactProvider} className="iconList" />
          <h3 className="title">{texts.billDetailTitle}</h3>
        </div>
        <BillDetails goBack={goBack} onSubmit={onSubmit} data={data} />
      </div>
      <Modal show={modal.show}>{modal.content}</Modal>
    </>
  );
};

export default DetailStatus;

const defaultModal = { show: false, content: null };

const states = {
  PAID_REJECTED: "PAID_REJECTED",
  DRAFT: "ENTERED",
  APPROVED: "APPROVED",
  PAID: "PAID",
};
